import '../../httpservices/core/ajax.httpservice.core';

class PharmacyHttpService {

    PageInitData() {
        return $.get('Patient/PreferredPharmacy/PageInitData');
    }

    GetPharmacies() {
        return $.get('Patient/PreferredPharmacy/GetPharmacies');
    }

    SearchPharmacies(searchText) {
        return $.get('Patient/PreferredPharmacy/SearchPharmacies?searchText=' + encodeURIComponent(searchText));
    }

    RemovePharmacy(pharmacyId) {
        return $.delete('Patient/PreferredPharmacy/DeletePharmacy?pharmacyId=' + pharmacyId);
    }

    GetPharmacyDetail(pharmacyId) {
        return $.get('Patient/PreferredPharmacy/GetPharmacyDetail?pharmacyId=' + pharmacyId);
    }

    SavePharmacy(pharmacyId) {
        return $.post('Patient/PreferredPharmacy/SavePharmacy', { PharmacyId: pharmacyId });
    }

    PatientsPreferredPharmaciesToDropDown() {
        return $.get('Patient/PreferredPharmacy/PharmaciesToDropDown?enableOutageResponse=1');
    }

    MskPharmaciesToDropDown() {
        return $.get('Patient/PreferredPharmacy/GetMSKCCPharmaciesToDropDown?enableOutageResponse=1');
    }

}

export const PharmacyHttpSvc = new PharmacyHttpService();